var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 96,
    viewBox: "0 0 51 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1261 94.7025L50.1936 73.0365C51.1612 72.2582 51.274 70.8904 50.4452 69.9816C49.6166 69.0728 48.1603 68.9668 47.1928 69.7453C47.1026 69.8179 47.0183 69.8969 46.9412 69.9816L27.7952 87.9427L27.7952 2.16654C27.7952 0.970066 26.7624 0 25.4883 0C24.2142 0 23.1816 0.970066 23.1816 2.16654L23.1816 87.9427L4.05881 69.9816C3.23018 69.0728 1.77394 68.9668 0.806347 69.7453C-0.161243 70.5238 -0.274033 71.8914 0.55479 72.8002C0.632103 72.8849 0.716148 72.964 0.806347 73.0365L23.8739 94.7026C24.7733 95.5426 26.2263 95.5426 27.1261 94.7025Z",
    fill: "#848484"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.09d1e5a59041f770a32e902138208265.svg";
export { ForwardRef as ReactComponent };